const state = {
  token: '',
};
const getters = {
  getToken: (State) => State.token,
};
const actions = {
};
const mutations = {
  setToken: (State, token) => {
      State.token = token;
  },
};

export default {
  actions,
  mutations,
  getters,
  state,
};
